import React from 'react'
import ProductDocuments from '../ProductDocuments/ProductDocuments'
import normalise from '../../helpers/normalise'
import * as Styled from './Description.styles'

import { useFeatureFlagContext } from '@/javascript/providers/FeatureFlagContext/FeatureFlagContext'

const Description = ({
  id,
  partNumber,
  media = {},
  descriptionText,
  specificationList,
  headerText = 'About this product',
  showCategoryNumber
}) => {
  const { PDP_V2_FLAG } = useFeatureFlagContext()
  const stripBreakTags = html => html.replace(/<br\s?[/\\]+>/g, '')
  const documents = media.pdfs || []
  const pdfDescriptions = {}
  documents.forEach(href => {
    if (media.meta[href]?.description) {
      pdfDescriptions[href] = media.meta[href].description
    }
  })
  const __html = stripBreakTags(normalise(descriptionText, specificationList)) //eslint-disable-line
  return (
    <Styled.Container id={id} data-test='product-description' PDP_V2_FLAG={PDP_V2_FLAG}>
      {headerText && <Styled.Heading>{headerText}</Styled.Heading>}
      <div className='product-description-content-text' itemProp='description' dangerouslySetInnerHTML={{ __html }} />
      {!!documents.length && (
        <ProductDocuments partNumber={partNumber} documents={documents} pdfDescriptions={pdfDescriptions} />
      )}
      {showCategoryNumber && (
        <Styled.CategoryNumber>
          <p>Category number:</p>
          <ul>
            <li>{partNumber}</li>
          </ul>
        </Styled.CategoryNumber>
      )}
    </Styled.Container>
  )
}

export default Description
